import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import { useFetch } from '../../../../hooks'
import { getTranslation, getDataByKey, getTitleByKey, renderData, isNotNilDataByKey, isNotNil, findIndexByKey } from '../../../../helpers'
import { Reproduction, Health, Biosensors, Notes } from './tabs'
import Drawer from '../../../../components/Drawer'
import Tabs from '../../../../modules/Tabs'
import Modal from '../../../../components/Modal'
import FormRemove from '../../components/FormRemove'
import FormEditCow from '../../components/FormEditCow'
import PageLoader from '../../../../components/PageLoader'
import { StyledDrawerItemWrapper, StyledDrawerItemText, StyledDrawerItemIcon } from '../../../../components/Drawer/styled'
import FormGenerateReport from '../../../../modules/forms/FormGenerateReport'
import Button from '../../../../components/inputs/Button'
import Icon from '../../../../components/Icon'
import HeadBar from '../../../../modules/HeadBar'
import Container from '../../../../components/Container'
import FooterBar from '../../../../modules/FooterBar';
import AddEvent from '../../components/AddEvent';
import ButtonDouble from '../../../../components/inputs/ButtonDouble';
import { Store } from '../../../../context/store';
import { inc, length, pathOr } from 'ramda';
import useBuffer from '../../../../hooks/useBuffer';
import FormAddNote from '../../components/FormAddNote';

const CowCard = () => {
    const { state: { cowsList } } = Store()
    const history = useHistory();
    const { state, state: { rowid = null } = {} } = useLocation();
    const [cow, setCow] = useState({ data: [] });
    const [notes, setNotes] = useState({ data: [], nextid: null });

    const { fetching, error, doFetch: getCowCard } = useFetch({
        url: `/cowcard?row_id=eq.${rowid}`,
        method: 'GET',
        lazy: true
    })

    const { doFetch: getCowNotes } = useFetch({
        url: '/rpc/get_cow_notes',
        method: 'POST',
        loader: false,
        state: false
    })

    const { index, setIndex, refetchBuffer, onClickPrevItem, onClickNextItem } = useBuffer({
        list: cowsList,
        doFetch: ({ item, loader }) => getCowCard({ url: `/cowcard?row_id=eq.${item.row_id}`, loader }),
        setItem: item => setCow(item)
    })

    const reFetchCowCard = (param = {}) => {
        const { loader = false, refetchCurr = true } = param;
        return refetchBuffer({ loader, refetchCurr });
    }

    useEffect(() => {
        if (cow.data.length > 0) {
            (async () => {
                const resNotes = await getCowNotes({
                    data: {
                        cowid: cow.data[0].row_id
                    }
                })
                if (resNotes) {
                    setNotes(resNotes)
                }
            })()
            history.replace({
                pathname: `/manage/herd/cow/${cow.data[0].row_no}`,
                state: {
                    ...state,
                    rowid: cow.data[0].row_id
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cow])


    useEffect(() => {
        if (isNotNil(rowid)) {
            if (index === null) {
                const currIndex = findIndexByKey('row_id', rowid, cowsList)
                setIndex(currIndex)
            }
        } else {
            history.push('/')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowid])

    const handleClickSaveNote = async () => {
        const res = await getCowNotes({
            data: {
                cowid: cow.data.length > 0 && cow.data[0].row_id
            }
        })
        if (res) {
            setNotes(res)
        }
    }
    const handleClickNextNotes = async () => {
        const res = await getCowNotes({
            data: {
                cowid: cow.data.length > 0 && cow.data[0].row_id,
                nextid: notes.nextid
            }
        })
        if (res) {
            setNotes(prevNotes => ({ data: res.data ? [...prevNotes.data, ...res.data] : [...prevNotes.data], nextid: res.nextid }))
        }
    }

    const renderDataState = renderData({ data: cow, error, fetching });
    const drawerTranslation = getTranslation(cow, 'menu-modal');

    return (
        <>
            {
                renderDataState({
                    fetching: () => (<><HeadBar /><PageLoader /></>),
                    error: error => (<><HeadBar /><Container><div>{error.toString()}</div></Container></>),
                    data: data => (
                        <Tabs
                            headBar={{
                                title: getDataByKey(data, 'title', ''),
                                children: (
                                    <Drawer
                                        drawerItems={[
                                            {
                                                customContent: ({ handleToggleIsOpenDrawer }) => (
                                                    <Modal
                                                        renderOpenButton={
                                                            ({ handleToggleIsOpenModal }) => (
                                                                <StyledDrawerItemWrapper onClick={handleToggleIsOpenModal}>
                                                                    <StyledDrawerItemIcon name='edit' />
                                                                    <StyledDrawerItemText>
                                                                        {drawerTranslation && drawerTranslation['edit']['form-button']}
                                                                    </StyledDrawerItemText>
                                                                </StyledDrawerItemWrapper>
                                                            )
                                                        }
                                                    >
                                                        {
                                                            ({ handleToggleIsOpenModal }) => (
                                                                <FormEditCow
                                                                    cowid={getDataByKey(cow, 'row_id', null)}
                                                                    onClickCancel={handleToggleIsOpenModal}
                                                                    onClickClose={
                                                                        () => {
                                                                            handleToggleIsOpenModal();
                                                                            handleToggleIsOpenDrawer();
                                                                        }
                                                                    }
                                                                    refetchCow={reFetchCowCard}
                                                                    translation={drawerTranslation && drawerTranslation['edit']['modal']}
                                                                />
                                                            )
                                                        }
                                                    </Modal>
                                                )
                                            }, {
                                                customContent: () => (
                                                    <Modal
                                                        renderOpenButton={
                                                            ({ handleToggleIsOpenModal }) => (
                                                                <StyledDrawerItemWrapper onClick={handleToggleIsOpenModal}>
                                                                    <StyledDrawerItemIcon name='remove' />
                                                                    <StyledDrawerItemText>
                                                                        {drawerTranslation && drawerTranslation['delete']['form-button']}
                                                                    </StyledDrawerItemText>
                                                                </StyledDrawerItemWrapper>
                                                            )
                                                        }
                                                    >
                                                        {
                                                            ({ handleToggleIsOpenModal }) => (
                                                                <FormRemove
                                                                    data={{
                                                                        cowid: getDataByKey(cow, 'row_id', null)
                                                                    }}
                                                                    url='/rpc/remove_cow'
                                                                    urlUndo='/rpc/remove_cow_undo'
                                                                    redirect='/manage/herdgrp'
                                                                    onClickCancel={handleToggleIsOpenModal}
                                                                    translation={drawerTranslation && drawerTranslation['delete']['modal']}
                                                                />
                                                            )
                                                        }
                                                    </Modal>
                                                )
                                            }, {
                                                customContent: () => (
                                                    <Modal
                                                        renderOpenButton={
                                                            ({ handleToggleIsOpenModal }) => (
                                                                <StyledDrawerItemWrapper onClick={handleToggleIsOpenModal}>
                                                                    <StyledDrawerItemIcon name='report' />
                                                                    <StyledDrawerItemText>
                                                                        {drawerTranslation && drawerTranslation['report']['form-button']}
                                                                    </StyledDrawerItemText>
                                                                </StyledDrawerItemWrapper>
                                                            )
                                                        }
                                                    >
                                                        {
                                                            ({ handleToggleIsOpenModal }) => (
                                                                <FormGenerateReport
                                                                    type="cow"
                                                                    dataKey="row_id"
                                                                    icon="cow"
                                                                    id={getDataByKey(cow, 'row_id', null)}
                                                                    report={getDataByKey(cow, 'report', {})}
                                                                    endpointExecute={'reportexecute'}
                                                                    onClickCancel={handleToggleIsOpenModal}
                                                                />
                                                            )
                                                        }
                                                    </Modal>
                                                )
                                            }
                                        ]}
                                    />
                                )
                            }}
                            tabs={
                                [{
                                    id: 'reproduction',
                                    name: getTitleByKey(data, 'procreation'),
                                    component: <Reproduction
                                        cowid={getDataByKey(data, 'row_id', null)}
                                        reproduction={getDataByKey(data, 'procreation', [])}
                                        biosensors={getDataByKey(data, 'biosensors')}
                                        refetchCow={reFetchCowCard}
                                    />,
                                    showTab: isNotNilDataByKey(data, 'procreation')
                                }, {
                                    id: 'health',
                                    name: getTitleByKey(data, 'health'),
                                    component: <Health
                                        cowid={getDataByKey(data, 'row_id', null)}
                                        health={getDataByKey(data, 'health', [])}
                                    />,
                                    showTab: isNotNilDataByKey(data, 'health')
                                }, {
                                    id: 'biosensors',
                                    name: getTitleByKey(data, 'biosensors'),
                                    component: <Biosensors
                                        cowid={getDataByKey(data, 'row_id', null)}
                                        biosensors={getDataByKey(data, 'biosensors')}
                                        refetchCow={reFetchCowCard}
                                    />,
                                    showTab: isNotNilDataByKey(data, 'biosensors')
                                },
                                {
                                    id: 'notes',
                                    name: getTitleByKey(data, 'notes'),
                                    headBarChildren: (
                                        <Modal
                                            renderOpenButton={
                                                ({ handleToggleIsOpenModal }) => (
                                                    <Button transparent noMargin onClick={handleToggleIsOpenModal}><Icon name='add' /></Button>
                                                )
                                            }
                                        >
                                            {
                                                ({ handleToggleIsOpenModal }) => (
                                                    <FormAddNote
                                                        type="cow"
                                                        endpoint="/rpc/setcownote"
                                                        id={getDataByKey(cow, 'row_id', null)}
                                                        translation={pathOr({}, ['add-note'], getDataByKey(cow, 'notes', {}))}
                                                        onClickCancel={handleToggleIsOpenModal}
                                                        onClickSave={handleClickSaveNote}
                                                    />
                                                )
                                            }
                                        </Modal>
                                    ),
                                    component: <Notes
                                        notesFromKey={getDataByKey(data, 'notes', null)}
                                        notes={notes}
                                        onClickNextNotes={handleClickNextNotes}
                                    />,
                                    showTab: isNotNilDataByKey(data, 'notes')
                                }
                                ]}
                        />
                    )
                })
            }
            <FooterBar noDivider>
                <Modal
                    renderOpenButton={
                        ({ handleToggleIsOpenModal }) => (
                            <Button transparent noMargin onClick={handleToggleIsOpenModal} style={{ marginRight: 'auto' }}><Icon name='add' /></Button>
                        )
                    }
                >
                    {
                        ({ handleToggleIsOpenModal }) => (
                            <AddEvent
                                cowid={getDataByKey(cow, 'row_id', null)}
                                cowno={getDataByKey(cow, 'row_no', null)}
                                {...getDataByKey(cow, 'quickbutton', {})}
                                refetchCow={reFetchCowCard}
                                handleToggleIsOpenModal={handleToggleIsOpenModal}
                            />
                        )
                    }
                </Modal>
                {
                    length(cowsList) !== 0 &&
                    <ButtonDouble style={{ marginLeft: 'auto' }} onClickLeft={onClickPrevItem} onClickRight={onClickNextItem} disabled={length(cowsList) === 1}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Icon name="cow" />
                            <div style={{ fontSize: '12px' }}>{`${index !== null && index > -1 ? inc(index) : '-'}/${length(cowsList)}`}</div>
                        </div>
                    </ButtonDouble>
                }
            </FooterBar>
        </>
    )
}

export default CowCard